import { render, staticRenderFns } from "./OfficeHours.vue?vue&type=template&id=16c78dde&scoped=true"
import script from "./OfficeHours.vue?vue&type=script&lang=js"
export * from "./OfficeHours.vue?vue&type=script&lang=js"
import style0 from "./OfficeHours.vue?vue&type=style&index=0&id=16c78dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c78dde",
  null
  
)

export default component.exports